var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicWithBackground = function SvgMicWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.618 24.557h.016-.016Zm.01 0a4.053 4.053 0 0 0 4.038-4.042V14.04a3.902 3.902 0 0 0-1.19-2.862 4.031 4.031 0 0 0-5.698 0 3.917 3.917 0 0 0-1.186 2.862v6.468a4.053 4.053 0 0 0 4.036 4.048Zm1.385 3.267a7.639 7.639 0 0 0 6.258-7.731 1 1 0 1 0-1.999.057 5.637 5.637 0 1 1-11.27 0 1 1 0 1 0-1.999-.057 7.637 7.637 0 0 0 6.986 7.829v.954c-.002.148.024.295.075.432.05.137.127.261.222.364.19.21.447.328.714.328a.962.962 0 0 0 .714-.328c.096-.103.173-.227.224-.363a1.19 1.19 0 0 0 .075-.433v-1.052Z",
    fill: "#6F6F6F"
  })));
};
export default SvgMicWithBackground;